import { z } from 'zod';
/** Tipos de imagen que se pueden subir (logo, categorías, productos). */
export const UPLOAD_CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
/** 5 MB. */
export const UPLOAD_MAX_BYTES = 5 * 1024 * 1024;
export const UPLOAD_EXTENSIONS = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
};
export const UPLOAD_TOO_LARGE_MESSAGE = 'La imagen pesa más de 5 MB';
export const UPLOAD_BAD_TYPE_MESSAGE = 'Subí una imagen JPG, PNG o WebP';
export const presignUploadSchema = z.object({
    contentType: z.enum(UPLOAD_CONTENT_TYPES, UPLOAD_BAD_TYPE_MESSAGE),
    /** Tamaño exacto del archivo en bytes: va firmado en la URL (Content-Length). */
    size: z.number().int().positive('El archivo está vacío').max(UPLOAD_MAX_BYTES, UPLOAD_TOO_LARGE_MESSAGE),
});
/** Error de validación del archivo en el cliente (antes de pedir el presign), o `null`. */
export function uploadFileError(file) {
    if (!UPLOAD_CONTENT_TYPES.includes(file.type))
        return UPLOAD_BAD_TYPE_MESSAGE;
    if (file.size <= 0)
        return 'El archivo está vacío';
    if (file.size > UPLOAD_MAX_BYTES)
        return UPLOAD_TOO_LARGE_MESSAGE;
    return null;
}
//# sourceMappingURL=uploads.js.map